import React from 'react';
import { AlertCircle, Battery, Cookie, Shirt, XCircle } from 'lucide-react';
export function PainPointsSection() {
  const pains = [{
    icon: <AlertCircle className="w-6 h-6 text-[#C17F6B]" data-id="element-130" />,
    text: 'Barriga dura e hinchazón constante'
  }, {
    icon: <Shirt className="w-6 h-6 text-[#C17F6B]" data-id="element-131" />,
    text: "Ropa que aprieta aunque 'comas normal'"
  }, {
    icon: <Cookie className="w-6 h-6 text-[#C17F6B]" data-id="element-132" />,
    text: 'Antojos tarde-noche y culpa al día siguiente'
  }, {
    icon: <Battery className="w-6 h-6 text-[#C17F6B]" data-id="element-133" />,
    text: 'Cansancio que vuelve todo más difícil'
  }, {
    icon: <XCircle className="w-6 h-6 text-[#C17F6B]" data-id="element-134" />,
    text: "'Hago lo mismo de siempre y ya no funciona'"
  }];
  return <section className="py-20 bg-white" data-id="element-135">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-136">
        <div className="text-center mb-16" data-id="element-137">
          <h2 className="text-3xl lg:text-4xl font-serif font-bold text-[#3D4852] mb-4" data-id="element-138">
            Lo que sientes es real <br data-id="element-139" />
            <span className="text-[#8B9A7D] italic" data-id="element-140">
              (y no es falta de voluntad)
            </span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-141">
            A los 45+, las señales de tu cuerpo cambian. No estás imaginando
            cosas, estás experimentando una nueva realidad hormonal.
          </p>
        </div>

        <div className="grid gap-6" data-id="element-142">
          {pains.map((pain, index) => <div key={index} className="flex items-center gap-6 p-6 bg-[#F5F0E8]/50 rounded-xl border border-[#F5F0E8] hover:border-[#C17F6B]/30 transition-colors" data-id="element-143">
              <div className="flex-shrink-0 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm text-[#C17F6B]" data-id="element-144">
                {pain.icon}
              </div>
              <p className="text-lg font-medium text-[#3D4852]" data-id="element-145">{pain.text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}